import { Action, createAction } from 'redux-act';

export const notificationShown = createAction<NotificationShownPayload>('NOTIFICATION_SHOWN');
export interface NotificationShownPayload {
  uuid: string;
}
export type NotificationShownActionType = Action<NotificationShownPayload>;

export interface NotificationShownUpdated {
  uuid: string;
}
export const notificationShownUpdated = createAction<NotificationShownUpdated>('NOTIFICATION_SHOWN_UPDATED');
